import { signal } from '@preact/signals-react'
import type { CartTotals } from '../commerce'

export const cartTotals = signal({
  fees: 0,
  merchantPays: false,
  total: 0,
  totalItems: 0,
  subtotal: 0,
} as CartTotals)
